import {defineStore} from 'pinia'
import {useContractStore} from "@/stores/contract"
import {IPromotionResource, IPromotionsTotals} from "@/interface/services/response/promotion.interface"
import PromotionService from "@/services/promotionService"

export const usePromotionStore = defineStore('promotion', {
    state: (): IPromotionState => ({
        promotions: null,
        totals: {} as IPromotionsTotals,
        lastUpdate: null,
        contractId: 0
    }),
    actions: {
        async initPromotionsFromContracts(id: number) {
            const response = await PromotionService.getPromotionsFromContracts([id]);
            this.promotions = response.promotions ?? [];
            this.totals = response.totals;
            this.lastUpdate = new Date();
        }
    },
    getters: {
        currentContractPromotions(state: IPromotionState) {
            return (active: boolean) : IPromotionResource[]|[] => {
                const contractStore = useContractStore()
                if (!contractStore.currentContract || !this.promotions) {
                    return [];
                }
                return this.promotions
            }
        }
    },
    persist: true
})

interface IPromotionState {
    promotions: IPromotionResource[]|null,
    totals: IPromotionsTotals|null,
    lastUpdate: Date|null,
    contractId: number
}

export type PromotionStore = ReturnType<typeof usePromotionStore>